import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import makeStyles from '@mui/styles/makeStyles';
import React, { useMemo } from 'react';

import Link from '@/components/Link';
import SnackbarNotification from '@/components/Snackbar/SnackbarNotification';
import { useExpertPaymentsConsoleEnabled } from '@/features/expert-payments/featureFlag';
import { borderColor } from '@/theme/colors';

import AdminHeader from './AdminHeader';
import ExpertShowcaseCategoryModel from './expertShowcase/ExpertShowcaseCategoryModel';
import ExpertShowcaseModels from './expertShowcase/ExpertShowcaseModels';
import ExpertShowcaseSectionModel from './expertShowcase/ExpertShowcaseSectionModel';
import LandingPageModels from './landingPage/LandingPageModels';
import SectorModels from './sector/SectorModels';
import SiteSettings from './siteSettings/SiteSettings';

const useStyles = makeStyles(() => ({
  root: {
    margin: 30,
    display: 'flex',
    flexDirection: 'column',
  },
  empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: 200,
  },
  menu: {
    border: `1px solid ${borderColor}`,
  },
  content: {
    border: `1px solid ${borderColor}`,
  },
  section: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
export default function Admin({ model, id }: any) {
  const s = useStyles();
  const expertPaymentsEnabled = useExpertPaymentsConsoleEnabled();

  const sections = useMemo(
    () => [
      {
        name: 'Marketing',
        models: [
          {
            path: 'landing_pages',
            name: 'Landing Page',
            component: LandingPageModels,
          },
          {
            path: 'expert_showcases',
            name: 'Expert Showcase',
            component: ExpertShowcaseModels,
          },
          {
            path: 'expert_showcase_categories',
            name: 'Expert Showcase Category',
            component: ExpertShowcaseCategoryModel,
            hidden: true,
          },
          {
            path: 'expert_showcase_sections',
            name: 'Expert Showcase Section',
            component: ExpertShowcaseSectionModel,
            hidden: true,
          },
        ],
      },
      {
        name: 'Operations',
        models: [
          {
            path: 'sectors',
            name: 'Sector Management',
            component: SectorModels,
          },
          {
            path: 'site_settings',
            name: 'Site Settings',
            component: SiteSettings,
          },
          // ENG-5624. `to` rather than `path`, because the expert-payments
          // console is NOT an /admin/:model — it is its own v2 route with its
          // own layout, and registering it as a model would hand it this tree's
          // generic CRUD scaffold and legacy chrome. It only needs the link.
          //
          // Conditional because the console is feature-gated: an environment
          // where it is dark must not advertise a link that 404s.
          ...(expertPaymentsEnabled
            ? [
                {
                  path: 'expert-payments',
                  to: '/admin/expert-payments',
                  name: 'Expert Payments',
                },
              ]
            : []),
        ],
      },
    ],
    [expertPaymentsEnabled]
  );

  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  const models = sections.reduce((a, s) => a.concat(s.models), []);
  // @ts-expect-error TS(2339) FIXME: Property 'path' does not exist on type 'never'.
  const modelSelected = models.find((m) => m.path === model);

  return (
    <>
      <AdminHeader />
      <div className={s.root}>
        <Grid container spacing={4}>
          <Grid item md={2}>
            <div className={s.menu}>
              <List>
                {sections.map((s) => {
                  const links = s.models
                    .filter((m: any) => !m.hidden)
                    .map((m: any) => (
                      <Link key={m.path} to={m.to ?? `/admin/${m.path}`}>
                        <ListItem
                          selected={m.path === model}
                          classes={{
                            // @ts-expect-error TS(2339) FIXME: Property 'section' does not exist on type '{ name:... Remove this comment to see the full error message
                            root: s.section,
                            // @ts-expect-error TS(2769) FIXME: No overload matches this call.
                            selected: s.sectionSelected,
                          }}
                        >
                          {m.name}
                        </ListItem>
                      </Link>
                    ));
                  return (
                    <>
                      <ListSubheader key={s.name} disableSticky>
                        {s.name}
                      </ListSubheader>
                      {links}
                    </>
                  );
                })}
              </List>
            </div>
          </Grid>

          <Grid item md={9}>
            <div className={s.content}>
              {modelSelected ? (
                // @ts-expect-error TS(2339) FIXME: Property 'component' does not exist on type 'never... Remove this comment to see the full error message
                React.createElement(modelSelected.component, {
                  model: modelSelected,
                  id,
                })
              ) : (
                <div className={s.empty}>Empty</div>
              )}
            </div>
          </Grid>
        </Grid>

        <SnackbarNotification />
      </div>
    </>
  );
}
